import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataProductsPage } from '../../../../redux/actions/pages/products';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { ALL_PRODUCTS_GET } from '../../../../apis';
import apiRequest from '../../../../utils/apiRequest'; 
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { handleChangeDataModalAddToStock } from '../../../../redux/actions/partials/modals/modalAddToStock';
import { handleChangeDataModalEditTransFactorNum } from '../../../../redux/actions/partials/modals/modalEditTransFactorNum'
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Select from 'react-select';


const AllProducts = () => {

	const dispatch = useDispatch();


	const { token } = useSelector(state => state.login);
    const { myProducts, allProducts, inputProductName, categories, inputCategory} = useSelector(state => state.products);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);
    

    useEffect(() => {
        dispatch(handleChangeDataProductsPage('inputProductName', ''));
        dispatch(handleChangeDataProductsPage('inputCategory', ''));
        apiProducts();
        // eslint-disable-next-line
    }, [AllProducts]);


    const [isSearchVisible, setIsSearchVisible] = useState(false);

    const [isHeadingElementsVisible, setIsHeadingElementsVisible] = useState(false);

    const [time, setTime] = useState(null);


    const apiProducts = (event) => {
        if(event !== undefined)
            event.preventDefault();

        if(! isBackdropLoading) {
            apiRequest({
                dispatch,
                endpoint: ALL_PRODUCTS_GET,
                method: 'get',
                data: {productName: inputProductName, category: inputCategory},
                token: token,
                successMessage: null,
                onSuccess: (res) => {
                    dispatch(handleChangeDataProductsPage('allProducts', res.products));
                    dispatch(handleChangeDataProductsPage('categories', res.categories));
                },
            });
        }

    };



    const showModalAddToStock = (key) => {
        dispatch(handleChangeDataModalAddToStock('isOpen', true));
        dispatch(handleChangeDataModalAddToStock('product', allProducts[key]));
    };


    const handleClickSearchBtn = () => {
        setIsSearchVisible(! isSearchVisible);
        setIsHeadingElementsVisible(false);
    };

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeDataProductsPage(name, value));
    };

    const handleChangeCatSelected = (option) => {
        dispatch(handleChangeDataProductsPage('inputCategory', (option ? option.value : '')));
    };


    return (
		<div className="app-content content container-fluid">
            <div className="content-wrapper">
                <div className="content-header row">
                </div>
                <div className="content-body">




                    <Row>
                        <Col className="col-xs-12">
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">محصولات </h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsHeadingElementsVisible(! isHeadingElementsVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isHeadingElementsVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse"><i className="icon-minus4"></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                            <li><a onClick={handleClickSearchBtn}><i className="icon-search"></i></a></li>
                                            <li><a onClick={() => apiProducts()} title="رفرش"><i className="icon-reload" style={{color: '#0100fe'}}></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card-body collapse in">

                                    {isSearchVisible && (
                                    <motion.div 
                                        className="card-block" id="div-search"
                                        initial={{ opacity: 0, height: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, height: "auto", scale: 1 }}
                                        exit={{ opacity: 0, height: 0, scale: 0.8 }}
                                        transition={{ duration: 0.5, ease: "easeOut" }} >
                                        <form onSubmit={apiProducts} >
                                            <div className="form-body" style={{overflow: 'unset !important'}} >
                                                <Row className="row">
                                                    <div className="form-group col-md-3">
                                                        <label class="c-label">بخشی از نام محصول</label>
                                                        <input name="inputProductName" value={inputProductName} onChange={handleChangeInputs} type="text" className="form-control" />
                                                    </div>
                                                    <div className="form-group col-md-3">
                                                        <label class="c-label">دسته بندی</label>
                                                        <Select options={categories} name="inputCategory"  onChange={handleChangeCatSelected} placeholder="انتخاب کنید" />
                                                    </div>
                                                </Row>
                                                <Row className="row">
                                                    <div className="form-group col-md-3">
                                                        <button type="submit" id="btn-search" className="btn btn-success w-100" name="search_btn" value="search" >
                                                            <i className="icon-search"></i> جستجو 
                                                        </button>
                                                    </div>
                                                </Row>
                                            </div>
                                        </form>
                                    </motion.div>
                                    )}

                                    <div className="table-responsive">
                                        <table className="table mb-0 table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{width: '1%'}} >#</th>
                                                    <th>تصویر</th>
                                                    <th>نام محصول</th>
                                                    <th>تنوع</th>
                                                    <th>کدمحصول</th>
                                                    <th>عملیات</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    allProducts.map((product, key) => {
                                                        return(
                                                            <tr>
                                                                <td> {key + 1} </td>
                                                                <td className="td-image" style={{maxWidth: '100px', textAlign: 'center'}}> <LazyLoadImage  src={product.image} alt={product.productTitle} height={70} /> </td>
                                                                <td style={{minWidth: '200px'}}> {product.productTitle} </td>
                                                                <td> {product.attributeTitle ? (product.attributeTitle + ': ' + product.attributeOptionTitle) : ''} </td>
                                                                <td> {product.sku} </td>
                                                                <td>
                                                                    { !product.inSellerStock &&
                                                                        <a href="#" style={{marginRight: '0'}} className="btn-details" title="افزودن به انبار" 
                                                                                onClick={() => showModalAddToStock(key)} >
                                                                            <i className="icon-android-add" style={{fontSize: '24px'}} ></i>
                                                                        </a>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <nav aria-label="Page navigation" className="text-xs-center" style={{marginTop: '3%'}} >

                                    </nav>
                                </div>
                            </div>
                        </Col>
                    </Row>





                </div>
            </div>
        </div>
    );
}

export default AllProducts;